import React, {Component} from 'react';
import {Container} from 'semantic-ui-react';
import AllSubmissions from './components/AllSubmissions';
import ProductionSubmissions from './components/Production';

import './App.css';
import Neo4jDirect from './components/Neo4jDirect';
class App extends Component {
  render() {
    return (
      <div>
        <div className="mt-4 ml-6 flex justify-center bg-grey-lighter">
          <div className="bg-teal-light font-extrabold text-center text-blue-darker border-2 border-grey m-4 p-4 w-1/4">SUBMITTED DATASETS</div>
        </div>
        <Container>
          <div className="m-4 p-4 bg-white">
            <h4>PRODUCTION</h4>
            <hr/>
            <ProductionSubmissions/>
          </div>
          <h4>PILOT</h4>
          <hr/>
          <AllSubmissions/>
          <Neo4jDirect/>
        </Container>

      </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js